export default "__VITE_ASSET__de9680b6__"